<!--suppress JSCheckFunctionSignatures, SassScssResolvedByNameOnly -->
<template>
  <form
    ref="form"
    :class="formClasses"
    method="POST"
    enctype="multipart/form-data"
    @drag="onDrag"
    @dragstart="onDrag"
    @dragend="onDragLeaveEnd"
    @dragover="onDragOverEnter"
    @dragenter="onDragOverEnter"
    @dragleave="onDragLeaveEnd"
    @drop="onDrop"
    @submit="onSubmit"
  >
    <div class="box__input">
      <svg
        class="box__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="43"
        viewBox="0 0 50 43"
      >
        <path
          d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
        />
      </svg>
      <div class="mb-1">
        <h5>El documento debe contener formato PDF y pesar menos de 30 MB</h5>
      </div>
      <input
        :class="hasFocus ? 'box__file has-focus' : 'box__file'"
        type="file"
        :accept="typeAccept"
        name="files[]"
        id="file"
        :data-multiple-caption="multipleCaption"
        multiple
        @focus="onInputFocus"
        @blur="onInputBlur"
        @change="onChange"
      />
      
      <label
        id="upload_file__nuevo_documento__draganddrop_button"
        v-if="!loading" 
        for="file"
      >
        <span class="box__dragndrop text-button mr-1"
          >Suelta tus archivos aquí o</span
        >
        <strong :class="eligeArchivoClasses">Elige un Archivo</strong>
      </label>
      <div v-else>
        {{ multipleCaption }}
      </div>
      <v-col
        md="4"
        offset-md="4"
      >
        <v-progress-linear
          v-if="loading"
          indeterminate
          rounded
          color="primary"
          height="6"
        ></v-progress-linear>
      </v-col>
      <button class="box__button" type="submit">Upload</button>
    </div>
    <div class="box__uploading">Uploading…</div>
    <div class="box__success">Done!</div>
    <div class="box__error">
      Error!
      <span></span>.
    </div>
  </form>
</template>

<script>
import { uploadWizardActions } from '@/modules/documents/store/uploadWizardStoreHelpers'
import { appThemeData, pushNotification } from '@/store/helpers'
import { PDFDocument } from 'pdf-lib'
import ConvertBytes from '@/utils/ConvertBytes'
import forge from 'node-forge'

export default {
  name: 'DragFiles',
  data() {
    return {
      advancedUpload: false,
      isDragOver: false,
      hasFocus: false,
      multipleCaption: '',
      droppedFiles: false,
      typeAccept: 'application/pdf',
      loading: false
    }
  },
  created() {
    this.advancedUpload = this.isAdvancedUpload()
  },
  computed: {
    ...appThemeData,
    eligeArchivoClasses() {
      return `mr-4 v-btn v-btn--contained v-size--default theme--dark ${this.appThemeSelectFileButtonColor}`
    },
    formClasses() {
      let baseClass = 'h100 box secondary lighten-1'
      if (this.advancedUpload) {
        baseClass = `${baseClass} has-advanced-upload`
      }

      if (this.isDragOver) {
        baseClass = `${baseClass} is-dragover`
      }

      return baseClass
    }
  },
  methods: {
    ...uploadWizardActions,
    isAdvancedUpload() {
      const div = document.createElement('div')
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      )
    },
    showFiles(files) {
      if (files.length > 1) {
        this.multipleCaption = `${files.length} elementos seleccionados`
      } else {
        this.multipleCaption = files[0].name
      }
    },
    onDrag(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    onDragOverEnter(e) {
      e.preventDefault()
      e.stopPropagation()
      this.isDragOver = true
    },
    onDragLeaveEnd(e) {
      e.preventDefault()
      e.stopPropagation()
      this.isDragOver = false
    },
    onDrop(e) {
      e.preventDefault()
      e.stopPropagation()
      this.isDragOver = false
      this.droppedFiles = e.dataTransfer.files
      this.onSubmit(e.dataTransfer.files)
    },
    onInputFocus() {
      this.hasFocus = true
    },
    onInputBlur() {
      this.hasFocus = false
    },
    onSubmit(files) {
      this.showFiles(files)
      let _this = this
      let noSupport = false
      let _continue = true
      const MAX = process.env.VUE_APP_AWS_DOCUMENT_MAX_SIZE
      const MIN = process.env.VUE_APP_AWS_DOCUMENT_MIN_SIZE
      files.forEach(file => {
        if (file.type != _this.typeAccept) {
          noSupport = true
        }
        if(file.size > MAX || file.size < MIN) {
          _continue = false
        }
      })
      if (noSupport) {
        pushNotification(
          this.$store,
          `El archivo que intenta usar no tiene el formato adecuado, por el momento solo puede seleccionar archivos pdf.`,
          'error',
          'left'
        )
        return
      }
      if (!_continue) {
        pushNotification(
          this.$store,
          `Recuerda que tu documento debe tener un tamaño entre "1KB" y "30MB",favor de verificar.`,
          'error',
          'left'
        )
        return
      }

      _this.loading = true

      Promise.all(
        [].map.call(files, function(file) {
          return new Promise(function(resolve, reject) {
            let reader = new FileReader()
            reader.onloadend = async function() {
              try {
                const pdf = await PDFDocument.load(reader.result)
                const converter = new ConvertBytes()
                const strBase64 = converter.bufferToBase64(reader.result)
                const md = forge.md.sha256.create()
                md.update(strBase64)
                const computeHash = md.digest().toHex()
                const count = pdf.getPages().length

                resolve({
                  bytesArray: reader.result,
                  hash: computeHash,
                  file: file,
                  pages: count
                })
              } catch(e) {
                reject(e)
              }
            }
            reader.readAsArrayBuffer(file)
          })
        })
      )
        .then(function(results) {
          return results
        })
        .then(fileList => {
          this.openUploadWizard()         
          this.setFiles(fileList)    
        })
        .catch(() => {
          pushNotification(
            this.$store,
            `El archivo que intenta usar está dañado o está siendo usado por otro programa.`,
            'error',
            'left'
          )
        })
        .finally(() => {
          _this.loading = false
          _this.multipleCaption = ''
        })
    },
    onChange(e) {
      this.onSubmit(e.target.files)
      e.target.value = null
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
/*Variables definidas en src/styles/_variables.css*/

.box {
  font-size: 1.25rem;
  position: relative;
  padding: 50px 20px;
  text-align: center;
}

.box__file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.box__dragndrop,
.box__uploading,
.box__success,
.box__error {
  display: none;
}

.box.has-advanced-upload {
  outline: 2px dashed $box-outline-color;
  outline-offset: -10px;

  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
}

.box.is-dragover {
  outline-offset: -20px;
  outline-color: #c8dadf;
  background-color: #fff;
}

.box__dragndrop,
.box__icon {
  display: none;
}
.box.has-advanced-upload .box__dragndrop {
  display: inline;
}

.box.has-advanced-upload .box__icon {
  width: 100%;
  height: 60px;
  fill: $box-icon-color;
  display: block;
  margin-bottom: 8px;
}

.box.is-uploading .box__input,
.box.is-success .box__input,
.box.is-error .box__input {
  visibility: hidden;
}

.box__uploading,
.box__success,
.box__error {
  display: none;
}
.box.is-uploading .box__uploading,
.box.is-success .box__success,
.box.is-error .box__error {
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;

  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.box__uploading {
  font-style: italic;
}
.box__success {
  -webkit-animation: appear-from-inside 0.25s ease-in-out;
  animation: appear-from-inside 0.25s ease-in-out;
}
@-webkit-keyframes appear-from-inside {
  from {
    -webkit-transform: translateY(-50%) scale(0);
  }
  75% {
    -webkit-transform: translateY(-50%) scale(1.1);
  }
  to {
    -webkit-transform: translateY(-50%) scale(1);
  }
}
@keyframes appear-from-inside {
  from {
    transform: translateY(-50%) scale(0);
  }
  75% {
    transform: translateY(-50%) scale(1.1);
  }
  to {
    transform: translateY(-50%) scale(1);
  }
}

.box__restart {
  font-weight: 700;
}
.box__restart:focus,
.box__restart:hover {
  color: $box-file-color;
}

.box__file + label {
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
}

.box__file + label:hover strong,
.box__file:focus + label strong,
.box__file.has-focus + label strong {
  color: $box-file-color;
}

.box__file:focus + label,
.box__file.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.no-js .box__file + label {
  display: none;
}

.no-js .box__button {
  display: block;
}
.box__button {
  font-weight: 700;
  color: #e5edf1;
  background-color: #39bfd3;
  display: none;
  padding: 8px 16px;
  margin: 40px auto 0;
}
.box__button:hover,
.box__button:focus {
  background-color: #0f3c4b;
}
.h100 {
  height: inherit;
}
</style>
